const THEME = {
  colors: {
    red: '#ff0000',
    greyRed: '#8c5a51',
    blue: '#0000FF',
    greyBlue: '#556b87',
    green: '#45d16a',
    yellow: '#ffd800',
    orange: '#f5a71f',
  },
}

export default THEME
